import axios from 'axios';
import Vue from 'vue';

// Create CheckList
/* export async function createCheckList({ commit }, payload) {
  await Vue.axios({
    method: 'POST',
    url: '/checklist/',
    data: {
      module: payload.module,
      child: payload.child,
      items: payload.items
    }
  })
    .then(response => {
      commit('addDataToCheckList', response.data);
    })
    .catch(error => {
      commit('error', error.message);
    });
} */

// List of Checklist
export async function fethCheckList({ commit, state }, data) {
  await Vue.axios({
    method: 'GET',
    url: '/child/' + data.childId + '/getChecklists/' + (data?.date ? '?date=' + data?.date : ''),
  })
    .then((response) => {
      commit('saveCheckListData', response.data);
    })
    .catch((error) => {
      commit('error', error);
    });
}

// List of Checklist Dates
export async function getChecklistsDates({ commit, state }, childId) {
  await Vue.axios({
    method: 'GET',
    url: '/child/' + childId + '/getChecklistsDates/',
  })
    .then((response) => {
      commit('saveCheckListDates', response.data);
    })
    .catch((error) => {
      commit('error', error);
    });
}

// Set child Valuation of items
export async function setChildCheckValues({ commit }, data) {
  let to_Response = '';
  let response = [];
  Object.keys(data.items).forEach(function(key, index) {
    response.push({
      id: data.items[key].id,
      value: data.items[key].approvedChild,
    });
  });
  await Vue.axios({
    method: 'POST',
    url: '/checklist/childValuate/',
    data: {
      items: response,
      date: data.date,
    },
  })
    .then((response) => {
      commit('cleanErrors');
      to_Response = {
        coins: response.data.coins,
        points: response.data.points,
        description: response.data.description,
        module: response.data.module,
        correct: true,
      };
    })
    .catch((error) => {
      commit('error', error);
      to_Response = { error: error.response.data, correct: false };
    });
  return to_Response;
}

export async function updateCoinValues({ commit }, data) {
  try {
    axios.put('/checklist/updateCoinValues/', {
      items: [data],
    });
  } catch (error) {
    console.log('(Checklist Action)', error);
  }
}

export async function updateCriteria({ commit }, { itemId, itemDescription, itemValue }) {
  try {
    axios.post(`/checklistItem/${itemId}/update_criteria/`, {
      description: itemDescription,
      value: itemValue,
    });
  } catch (error) {
    console.log('(Checklist Action)', error);
  }
}

// Set Parent Valuation of items
export async function setParentCheckValues({ commit }, data) {
  const { items = [], date, child = 0 } = data;
  try {
    await axios.post('/checklist/parentValuate/', { items, date, child });
    commit('cleanErrors');
  } catch (error) {
    commit('error', error);
    throw new Error({ message: '[Checklist|Save]', error });
  }
}

export async function createCriteria({ commit }, payload) {
  let to_Response = '';
  ////console.log(payload)
  await Vue.axios({
    method: 'POST',
    url: '/checklist/createCriteria/',
    data: payload,
  })
    .then((response) => {
      //console.log("createResponse", response)
      commit('addCriteriaCreated', response.data);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function ModifyCriterion({ commit }, payload) {
  await Vue.axios({
    method: 'POST',
    url: '/checklist/',
    data: payload,
  })
    .then((response) => {
      //console.log("modifyResponse", response)
      commit('addCriteriaToCheckList', response.data);
    })
    .catch((error) => {
      //console.log(error)
    });
}

export async function DeleteCriterion({ commit }, payload) {
  await Vue.axios({
    method: 'DELETE',
    url: `/checklistItem/${payload.itemId}/`,
  })
    .then(() => {
      commit('removeItemFromList', payload);
    })
    .catch((error) => {
      //console.log(error)
    });
}

export async function resetItemsCount({ commit }, { moduleIndex, childId, items }) {
  if (items && childId) {
    const itemsId = itemsId.map((item) => ({ id: item.id }));

    try {
      axios.post('/checklistItem/reset_count/', {
        child: childId,
        items: itemsId,
      });
      commit('resetCount', {
        moduleIndex: moduleIndex,
        items: itemsId,
      });
    } catch (error) {
      console.log('(actions)', error);
    }
  }
}

